import { Component, input } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { DisplayComponent } from 'app/driver-pay/persistence/core/components/displays/DisplayComponent';
import { MteFormatNumberWrapper } from '@mortar/angular/elements/utilities/format-number';

@Component({
  selector: 'number-display',
  template: `
    @let val = value();
    @if (val !== undefined) {
      <mte-format-number
        type="decimal"
        [maximumFractionDigits]="2"
        [minimumFractionDigits]="2"
        id="{{ this.id() ?? value() }}"
        [value]="asNumber(val)" />
    }
  `,
  standalone: true,
  imports: [MtrFormFieldModule, MteFormatNumberWrapper],
})
export class NumberDisplayComponent implements DisplayComponent {
  id = input<string>();
  value = input.required<object | undefined>();

  asNumber(val: object) {
    return val as unknown as number;
  }
}
